import React, { useEffect, useState } from "react";
import BingoCards from "./BingoCards";
import UserProfile from "./UserProfile";
import BingoTickets from "./BingoTickets";
import { ticketsProps } from "../components/apis/getTickets";
import Timer, { RemainingTimer } from "./Timer";
import useWebSocket from "./WebSocketManager";
import { drawDetailsProps } from "./apis/getDrawDetail";
import useWindowSize from "./utils/useWindowSize";
import { drawId, Token } from "./urlParams";
import {
  animateBingoBall,
  setBingoAnimationVisiblity,
} from "./pixi-app/bridge";
import { UserProps } from "./apis/user";
import { winnerList, winnerListProps } from "./apis/winner";
import { closeModalData } from "../App";
import {
  BALL_COUNT_URL,
  REMAINING_COUNT_SOCKET_URL,
  ZEGO_APP_ID,
  ZEGO_SERVER_URL,
} from "../envVariables";
import { unlockAudioContext } from "../hooks/unlockAudioContext";
import useCreateSound from "../hooks/useCreateSound";
import { SETTLEMENT_TYPE } from "./pixi-app/core/constants";
import ZegoCloudStream from "./ZegoCloudStream/ZegoCloudStream";
import ManualNumber from "./ManualNumber/ManualNumber";
interface BingoPageProps {
  ticketData: ticketsProps | undefined;
  drawDetails: drawDetailsProps | undefined;
  handleBally?: (numbers: number[]) => void;
  drawTime: string | Date | undefined;
  handleCloseModal: (data: closeModalData) => void;
  handleShowWinnersModal: (status: boolean) => void;
  userWallet: UserProps | undefined;
  userWalletAmount?: any;
  zegoToken?: any;
  showWinners: boolean;
}

export interface remainingPatternsProps {
  patterns: {
    [key: string]: number;
  };
  totalRemaining: number;
  totalRemainingPrice: number;
}
export const storageKey = `calledNumbers_${drawId}`;

const BingoPage: React.FC<BingoPageProps> = ({
  ticketData,
  showWinners,
  userWalletAmount,
  userWallet,
  handleCloseModal,
  handleShowWinnersModal,
  drawDetails,
  drawTime,
  handleBally,
  zegoToken,
}) => {
  const [isExpired, setIsExpired] = useState(false);
  const [autoClaim, setAutoClaim] = useState<boolean>(false);
  const [remainingPatterns, setRemainingPatterns] = useState<
    remainingPatternsProps | undefined
  >();
  const [isSocketNum, setIsSocketNum] = useState<boolean>(false);
  let count;
  const [showBingoAnimation, setShowBingoAnimation] = useState<boolean>(false);
  const [calledNumbers, setCalledNumbers] = useState([]);
  const maxNumberRange = drawDetails ? drawDetails.draw.game.maxNumberRange : 0;
  const { playSound } = useCreateSound();
  const { width, height } = useWindowSize();
  const [winners, setWinner] = useState<winnerListProps[]>();
  const [gameEnds, setgameEnds] = useState<boolean>(false);
  const [beforeTimerEnds, setBeforeTimerEnds] = useState(false);
  const isLiveDraw =
    drawDetails?.draw?.settlementType === SETTLEMENT_TYPE?.LIVE_DRAW;
  const isRNG =
    drawDetails?.draw?.settlementType === SETTLEMENT_TYPE?.RANDOM_NUMBER_GENERATOR_DRAW;
  const isManual =
    drawDetails?.draw?.settlementType === SETTLEMENT_TYPE?.MANUAL_NUMBER_DRAW;
  useEffect(() => {
    const getWinners = async () => {
      const data = await winnerList();
      setWinner(data);
      if (data && data.length > 0) {
        handleShowWinnersModal(true);
      } else {
        handleCloseModal({ status: true, test: "The game has ended." });
      }
    };

    if (showWinners || gameEnds) {
      getWinners();
    }
  }, [showWinners, gameEnds]);

  useEffect(() => {
    const handleUnlock = () => {
      unlockAudioContext();
      window.removeEventListener("scroll", handleUnlock);
      window.removeEventListener("click", handleUnlock);
      window.removeEventListener("touchstart", handleUnlock);
    };

    window.addEventListener("scroll", handleUnlock);
    window.addEventListener("click", handleUnlock);
    window.addEventListener("touchstart", handleUnlock);

    return () => {
      window.removeEventListener("scroll", handleUnlock);
      window.removeEventListener("click", handleUnlock);
      window.removeEventListener("touchstart", handleUnlock);
    };
  }, []);

  useEffect(() => {
    if (showBingoAnimation) {
      setTimeout(() => {
        setShowBingoAnimation(false);
      }, 1500);
    }
  }, [showBingoAnimation]);

  const handleClaimAnimation = (status: boolean) => {
    setShowBingoAnimation(status);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const { isExpired, beforeTime } = RemainingTimer(drawTime);
      setIsExpired(isExpired);
      setBeforeTimerEnds(beforeTime);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [drawTime]);

  useEffect(() => {
    if (drawId) {
      try {
        if (isLiveDraw) {
          const hasMain = drawDetails?.draw?.drawDetails;
          setCalledNumbers(hasMain ? drawDetails?.draw?.drawDetails : []);
        } else {
          const storedData = window.localStorage.getItem(storageKey);
          setCalledNumbers(storedData ? JSON.parse(storedData) : []);
        }
      } catch (error) {
        setCalledNumbers([]);
      }
    }
  }, [drawId, storageKey, drawDetails, isLiveDraw]);

  const handleData = (data: any) => {
    playSound(data?.drawNumber);
    setIsSocketNum(true);
    setCalledNumbers(data.allDrawNumbers);
    window.localStorage.setItem(
      storageKey,
      JSON.stringify(data.allDrawNumbers)
    );
    if (data.gameEnds) {
      setgameEnds(true);
    } else if (data.message && !data.gameEnds) {
      handleCloseModal({
        status: true,
        test: "The game has been cancelled, and refunds have been processed",
      });
    }
  };

  useEffect(() => {
    if (remainingPatterns && remainingPatterns.totalRemaining === 0) {
      handleShowWinnersModal(true);
    }
  }, [remainingPatterns, handleShowWinnersModal]);

  const remaininghandleData = (data: any) => {
    setRemainingPatterns(data.remainingClaimCount);
    if (data.remainingClaimCount <= 0) {
      handleShowWinnersModal(true);
    }
  };

  useWebSocket(
    REMAINING_COUNT_SOCKET_URL,
    "game_status",
    remaininghandleData,
    beforeTimerEnds,
    Token,
    "",
    showWinners
  );
  useWebSocket(
    BALL_COUNT_URL,
    "bingo",
    handleData,
    beforeTimerEnds,
    Token,
    "",
    showWinners
  );

  const isMobile = width <= 1024;

  const toggleAutoClaim = (prev: boolean) => {
    setAutoClaim(!prev);
  };

  useEffect(() => {
    if (isExpired) {
      if (isRNG) {
        setBingoAnimationVisiblity();
      }
      if (isSocketNum) {
        if (calledNumbers && calledNumbers.length > 0) {
          const latestNumber = calledNumbers[calledNumbers.length - 1];
          if (isRNG) {
            animateBingoBall(
              calledNumbers,
              latestNumber,
              maxNumberRange,
              (count = calledNumbers.length)
            );
          }
        }
      }
    }
  }, [calledNumbers, maxNumberRange, isExpired, isSocketNum, isRNG]);

  const getGameName = drawDetails ? drawDetails.draw.game.name : "BINGO";
  const text = getGameName.charAt(0).toUpperCase() + getGameName.slice(1);

  return (
    <div
      className={`w-full relative flex flex-col  min-h-[550px]    h-screen pb-2`}
    >

      {/* heading */}
      <div className="flex justify-center items-center md:py-4 py-2 xl:py-4 md:px-4 px-2">
        <h1
          className={` md:text-2xl text-base  max-w-[600px] font-bold text-[#40CDF9] z-40 drop-shadow-[0_0_10px_rgba(0,200,255,0.8)]`}
        >
          {width <= 620 && text.length >= 15
            ? text.slice(0, 15) + "..."
            : width <= 950 && text.length > 15
              ? text.slice(0, 15) + "..."
              : text}
        </h1>
      </div>

      {/* bingo numbers section */}

      <div className="flex  gap-4 md:gap-10  z-30 justify-between  w-full md:px-4 px-2 ">
        <div
          className={`lg:flex-shrink-0 2xl:min-w-[300px]`}
        >
          {!isExpired && (
            <div className={`flex  h-full w-full`}>
              <Timer drawTime={drawTime} />
            </div>
          )}
          {isExpired && isLiveDraw && zegoToken && userWallet && (
            <ZegoCloudStream
              appId={Number(ZEGO_APP_ID)}
              serverUrl={ZEGO_SERVER_URL}
              zegoToken={zegoToken}
              userData={userWallet}
              setCalledNumbers={setCalledNumbers}
            />
          )}
          {isExpired && isManual && (
            <ManualNumber
              setCalledNumbers={setCalledNumbers}
              storageKey={storageKey}
              setgameEnds={setgameEnds}
              handleCloseModal={handleCloseModal}
              setIsSocketNum={setIsSocketNum}

            />
          )}

        </div>
        <div className=" xl:flex hidden self-center flex-grow justify-start w-full max-h-[260px]">
          <BingoCards
            maxNumbers={maxNumberRange}
            calledNumbers={calledNumbers}
            drawDetails={drawDetails}
          />
        </div>
        <div
          className={`flex-shrink-0`}
        >
          <UserProfile
            userWalletAmount={userWalletAmount}
            remainingPatterns={remainingPatterns}
            userWallet={userWallet}
            isMobile={isMobile}
            drawDetails={drawDetails}
            autoClaim={autoClaim}
            toggleAutoClaim={toggleAutoClaim}
          />
        </div>
      </div>
      <div className="flex  xl:hidden  justify-start w-full max-h-[260px] mt-4">
        <BingoCards
          maxNumbers={maxNumberRange}
          calledNumbers={calledNumbers}
          drawDetails={drawDetails}
        />
      </div>

      <div className="mt-4">
        <BingoTickets
          handleClaimAnimation={handleClaimAnimation}
          calledNumbers={calledNumbers}
          autoHighlightPattern={autoClaim}
          ticketData={ticketData}
          drawDetails={drawDetails}
          remainingPatterns={remainingPatterns}
        />
      </div>

      {showBingoAnimation && (
        <div className="absolute z-50  justify-center items-center  flex w-full">
          <img
            src="/assets/Bingo.gif"
            alt="Bingo!"
            className="w-full h-full object-contain"
          />
        </div>
      )}
    </div>
  );
};

export default BingoPage;
